const search = window.location.search.substring(1);
const convertPathname = (pathname: string) => {
  return {
    pathname: `${pathname ? '/' + pathname : ''}`,
    search: '?' + search,
  };
};

export const PATH = {
  DEFAULT: convertPathname('home'),
  ANALYTICS: convertPathname('analytics'),
  WIDGETS: convertPathname('widgets'),
  FORM_ANSWER: convertPathname('form-answer'),
  FORM_ANSWER_DETAIL: convertPathname('form-answer/detail/:id'),
  NEW_WIDGET: convertPathname('widgets/create'),
  EDIT_WIDGET: convertPathname('widgets/:id'),
  APP_BRIDGE_MODAL: convertPathname('form-create-button'),
  CONTACT_FORM: convertPathname('contact-form'),
};
